export default "__VITE_ASSET__BF6l$$W3__"